G.Text = function(
	x,
	y,
	txt,
	style,
	anchor,
	maxWidth,
	maxHeight,
	textWrap,
	align,
	optDontDecreaseFontSize,
	optDownscaleToFit,
	optScaleUniformly
) {

	if (typeof style !== 'object'){
		style = G.Utils.clone(G.Text.styles[style]);
	}

	G.Text.setMaxWidth(this, maxWidth || Infinity);
	G.Text.setMaxHeight(this, maxWidth || Infinity);

	if (textWrap){
		style.wordWrap = true;
		style.wordWrapWidth = maxWidth;
		style.align = align || 'left';
	}

	Phaser.Text.call(this,game,x,y,txt,style);

	if (style.lineSpacing) {
		this.lineSpacing = style.lineSpacing;		
	}


	if (anchor) {
    if (typeof anchor == 'number') { 
        this.anchor.setTo(anchor);
    }else {
        this.anchor.setTo(anchor[0],anchor[1]);
    }
  }

  this.customComponents.text.scaleUniformly = optScaleUniformly;

  if (optDownscaleToFit) {
    this.applyMaxSizeConstraint();
  }
};

G.Text.prototype = Object.create(Phaser.Text.prototype);

// Text component

G.Text.setMaxWidth = function setMaxWidth(target, width) {
	G.Text.ensureTextComponentAvailable(target);
	target.customComponents.text.maxWidth = width;
};

G.Text.setMaxHeight = function setMaxHeight(target, height) {
	G.Text.ensureTextComponentAvailable(target);
	target.customComponents.text.maxHeight = height;
};

G.Text.ensureTextComponentAvailable = function ensureTextComponentAvailable(target) {
	target.customComponents = target.customComponents || {};
	target.customComponents.text = target.customComponents.text || {};
};

//

G.Text.styles = {};

G.Text.addStyle = function(name,obj){
	G.Text.styles[name] = obj;
};

G.Text.prototype.applyMaxSizeConstraint = function() {
	this.scale.setTo(1);
	this.width  = Math.min(this.width,  this.customComponents.text.maxWidth);
	this.height = Math.min(this.height, this.customComponents.text.maxHeight);
	if (this.customComponents.text.scaleUniformly) {
		var minScale = Math.min(this.scale.x, this.scale.y);
		this.scale.setTo(minScale);
	}
};

G.Text.prototype.setText = function(txt) {
	Phaser.Text.prototype.setText.call(this,txt);
	this.applyMaxSizeConstraint();
};


G.TextCounter = function(x,y,amount,style,anchor,maxWidth,config){

	this.amount = amount;
	this.amountDisplayed = amount;

	G.Text.call(this,x,y,amount === null ? '...' : amount.toString(),style,anchor,maxWidth);

	config = config || {lerpValue: 0.5};

	//addConfig
	this.lerp = true;
	this.lerpValue = config.lerpValue;

	this.stepCurrent = 0;
	this.step = 0;

};

G.TextCounter.prototype = Object.create(G.Text.prototype);

G.TextCounter.prototype.setAmount = function(amount,immediately){

	this.amount = amount;
	if (immediately) {
		this.amountDisplayed = amount;
		this.setText(this.amountDisplayed.toString());
	}

};

G.TextCounter.prototype.changeAmount = function(change,immediately){

	this.amount += change;
	if (immediately) {
		this.amountDisplayed = this.amount;
		this.setText(this.amountDisplayed.toString());
	}

};

G.TextCounter.prototype.update = function(){

	if (this.amountDisplayed != this.amount && this.stepCurrent-- <= 0){
		this.stepCurrent = this.step;
		if (this.lerp) this.lerpUpdate();
	}

};

G.TextCounter.prototype.lerpUpdate = function(){

    this.amountDisplayed = (G.lerp(this.amountDisplayed,this.amount,this.lerpValue,0.2));
    this.setText(Math.round(this.amountDisplayed).toString());

};